import React from 'react';

function Card({ pageLink, imageLink, title, text, source, sourceClass, className = 'article-card reveal' }) {
  return (
    <div className={className}>
      <span className={`article-source ${sourceClass}`}>{source}</span>
      <h3 className="article-title">{title}</h3>
      <p className="article-excerpt">{text}</p>
      <a href={pageLink} target="_blank" rel="noopener noreferrer" className="article-link">
        Read Article
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </a>
    </div>
  );
}

export default Card;
